import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import styles from "../../_css/UI.module.css";

const COLORS = ["#fff", "#BBE1FF33"];

const PlanGraph = ({ totalDays, remainingDays }) => {
  const data = [
    { name: "English", value: remainingDays },
    { name: "Arabic", value: totalDays - remainingDays },
  ];
  return (
    <div className={styles.planGraphCard}>
      <ResponsiveContainer width="100%" height={80}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={32}
            outerRadius={40}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
            labelLine={false}
            // label={renderCustomizedLabel}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index]}
                stroke={COLORS[index]}
              />
            ))}
          </Pie>
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={32}
            fontWeight="bold"
            fill="#fff"
          >
            {remainingDays}
          </text>
        </PieChart>
      </ResponsiveContainer>
      {/* <div className={styles.legendRow}>
      <span className={styles.legendDot} style={{ background: COLORS[1] }} /> Arabic
      <span className={styles.legendDot} style={{ background: COLORS[0], marginLeft: 24 }} /> English
    </div> */}
    </div>
  );
};

export default PlanGraph;
